module.exports = __webpack_public_path__ + "static/media/twitter.8eb471a0.svg";